import { useMaterialUIController } from "context";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAccess } from "hooks/useAccess";
import {
  buildRouteAccessMap,
  resolveAccessForPath,
} from "helpers/filterRoutesByAccess";
import {
  DEFAULT_ROUTE_ACCESS,
  EXTRA_ROUTE_ACCESS,
} from "helpers/routeAccess.config";
import routes from "routes";

const routeAccessMap = buildRouteAccessMap(routes as any[]);

const AUTHENTICATED_PUBLIC_PATHS = new Set(["/pages/sem-permissao"]);

export default function RoutePrivate() {
  const [controller] = useMaterialUIController();
  const { isAuthencated } = controller;
  const { pathname } = useLocation();
  const access = useAccess();

  const requirement = useMemo(() => {
    return (
      resolveAccessForPath(pathname, routeAccessMap, EXTRA_ROUTE_ACCESS) ??
      DEFAULT_ROUTE_ACCESS
    );
  }, [pathname]);

  if (!isAuthencated) {
    return <Navigate to="/authentication/sign-in/basic" replace />;
  }

  if (!access.canAccessPanel) {
    return <Navigate to="/authentication/sign-in/basic" replace />;
  }

  if (AUTHENTICATED_PUBLIC_PATHS.has(pathname)) {
    return <Outlet />;
  }

  if (!access.canAccess(requirement)) {
    return <Navigate to="/pages/sem-permissao" replace />;
  }

  return <Outlet />;
}
